import React, { useState, useEffect, useRef } from 'react';
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps';

const MapsGeolocator = ({position, zoom }) => {
  const [posicionActual, setPosicionActual] = useState(null);
  const [gpsError, setGpsError] = useState(null);
  const mapRef = useRef(null);

  // Obtener la ubicación al cargar
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setPosicionActual({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
         
          setGpsError(null);
        },
        (error) => {
          setGpsError("No se pudo obtener la ubicación.");
        }
      );
    } else {
      setGpsError("La geolocalización no está soportada en este navegador.");
    }
  }, []);

  // Centrar el mapa cada vez que cambia la posición
  useEffect(() => {
    if (posicionActual && mapRef.current) {
       //console.log("Posición actual geolocator:", posicionActual);
      mapRef.current.panTo(posicionActual);
      mapRef.current.setZoom(zoom || 16);
    }
  }, [posicionActual, zoom]);

  useEffect(() => {
  if (posicionActual ) {
    position(posicionActual);
    //console.log("Posición actual geolocator:", posicionActual);
  }
}, [posicionActual]);

  return (
    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
      <div style={{ width: '100%', height: '500px', position: 'relative', borderRadius: 12, overflow: 'hidden' }}>
        {gpsError && (
          <div style={{
            position: 'absolute',
            top: 20,
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#fff3cd',
            color: '#856404',
            padding: '12px 24px',
            borderRadius: 8,
            boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
            zIndex: 1000
          }}>
            <b>Permiso de ubicación requerido:</b><br />
            {gpsError}
          </div>
        )}
        <Map
          ref={mapRef}
          style={{ width: '100%', height: '100%' }}
          defaultCenter={posicionActual !== null ? posicionActual : { lat: 9.013518891975, lng: -79.48994905282501 }}
          defaultZoom={zoom}
        >
          {posicionActual && (
            <Marker position={posicionActual} title="Tu ubicación" />
          )}
        </Map>
        <div style={{
          position: 'absolute',
          top: 10,
          left: 10,
          background: '#fff',
          padding: 10,
          borderRadius: 8,
          boxShadow: '0 2px 8px rgba(0,0,0,0.10)'
        }}>
          {/* Puedes agregar controles aquí si lo necesitas */}
        </div>
      </div>
    </APIProvider>
  );
};

export default MapsGeolocator;